export const getters = {
  items: (state) => state.items,
  headerItems: (state) => state.headerItems,
};
